export default "__VITE_ASSET__CoN2s$f8__"